import { Getters } from 'vuex-smart-module';

import PagesState from './state';

export default class PagesGetters extends Getters<PagesState> {}
